// Recovered compiled webpack factory 77519. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    let t = parseInt(e.slice(0, 2), 16),
      r = (t >> 1) & 63,
      n = Array(6);
    for (let e = 0; e < 6; e++) {
      let t = (r >> (5 - e)) & 1;
      n[e] = 1 === t;
    }
    return {
      type: 1 == ((t >> 7) & 1) ? "use-cache" : "server-action",
      usedArgs: n,
      hasRestArgs: 1 == (1 & t),
    };
  }
  function n(e, t) {
    let r = Array(e.length);
    for (let n = 0; n < e.length; n++)
      ((n < 6 && t.usedArgs[n]) || (n >= 6 && t.hasRestArgs)) && (r[n] = e[n]);
    return r;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      extractInfoFromServerReferenceId: function () {
        return r;
      },
      omitUnusedArgs: function () {
        return n;
      },
    }));
}
